(function () {
    'use strict';

    angular
        .module('app.mentionManagementLog')
        .factory('mentionManagementLogService', ['$q', '$http', '$rootScope',
            function ($q, $http, $rootScope) {
                var service = {};

                function checkResponse(data) {
                  return data;
                }

                function getMessage(data) {
                  if (data) {
                    return data.message;
                  }
                  return false;
                }

                function handleRequest(url, method, params, loader) {
                    var deferred = $q.defer();

                    var req = {
                        url: url,
                        method: method,
                        data: JSON.stringify(params),
                        loader: loader
                    } 

                    $http(req)
                        .success(function (data) {
                        var dataRes = angular.fromJson(data);

                        if (checkResponse(dataRes)) {
                            deferred.resolve(dataRes);
                        } else {
                            deferred.reject(getMessage(dataRes));
                        }
                    })
                        .error(function (error) {
                            deferred.reject(error);
                        });

                    return deferred.promise;
                }

                function getMentionManagementLog(user_id, from_date, to_date, page_no, page_size, loader) {
                    var url_getMentionManagementLog = $rootScope.apiUrl + 'mention/getMentionManagementLog?user_id=' + user_id + '&from_date=' + from_date + '&to_date=' + to_date + '&page_no=' + page_no + '&page_size=' + page_size;
                    return handleRequest(url_getMentionManagementLog, 'GET', null, loader);
                }

                function getNumberOfMentionManagementLog(user_id, from_date, to_date, loader) {
                    var url_getNumberOfMentionManagementLog = $rootScope.apiUrl + 'mention/getNumberOfMentionManagementLog?user_id=' + user_id + '&from_date=' + from_date + '&to_date=' + to_date;
                    return handleRequest(url_getNumberOfMentionManagementLog, 'GET', null, loader);
                }

                function getNumberOfMentionApprovedAndApprovalRate(user_id, from_date, to_date, loader) {
                    var url_getNumberOfMentionApprovedAndApprovalRate = $rootScope.apiUrl + 'mention/getNumberOfMentionApprovedAndApprovalRate?user_id=' + user_id + '&from_date=' + from_date + '&to_date=' + to_date;
                    return handleRequest(url_getNumberOfMentionApprovedAndApprovalRate, 'GET', null, loader);
                } 

                function getNumberOfTranslationsCompleted(user_id, from_date, to_date, loader) {
                    var url_getNumberOfTranslationsCompleted = $rootScope.apiUrl + 'mention/getNumberOfTranslationsCompleted?user_id=' + user_id + '&from_date=' + from_date + '&to_date=' + to_date;
                    return handleRequest(url_getNumberOfTranslationsCompleted, 'GET', null, loader);
                }

                service.getMentionManagementLog = getMentionManagementLog;
                service.getNumberOfMentionManagementLog = getNumberOfMentionManagementLog;
                service.getNumberOfMentionApprovedAndApprovalRate = getNumberOfMentionApprovedAndApprovalRate;
                service.getNumberOfTranslationsCompleted = getNumberOfTranslationsCompleted;
                return service;
            }
        ]);
})();
